import { createApp } from 'vue'
import QuoteGenerator from '../components/QuoteGenerator.vue'

const element = document.getElementById('quote-generator-app')
const data = element.dataset
const app = createApp(QuoteGenerator, { ...data })
app.mount('#quote-generator-app')
